import { Cog } from '../assets/icons'
import { MainLayout } from './'
import { SettingsContentSidebar } from '../components/misc'

const SettingsLayout = ({ children, pageTitle }) => {
  return (
    <MainLayout className="page-settings" pageTitle={pageTitle} >
      <div className="settings-content">
        <SettingsContentSidebar />
        <div className="settings-content__main">
          {children}
        </div>
      </div>
    </MainLayout>
  )
}

export default SettingsLayout